/* GarmsGoblin glitch-in reveal (class names kept from the original print-head reveal). Elements with .ggprint run once:
   data-print="load"  -> when their image has loaded (hero)
   data-print="view"  -> when they first scroll into view (section titles) */
(function () {
  if (window.__ggPrint) return;
  window.__ggPrint = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function done(el) { el.classList.remove('is-printing'); el.classList.add('is-printed'); }

  function run(el) {
    if (el.__ggRun) return;
    el.__ggRun = true;
    if (reduce) { done(el); return; }
    var img = el.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (src) el.style.setProperty('--gg-src', 'url("' + src.replace(/"/g, '%22') + '")');
    el.classList.add('is-printing');
    var scan = el.querySelector('.ggprint__scan');
    var finish = function () { done(el); };
    if (scan) scan.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 2000); // safety net
  }

  function whenLoaded(el, cb) {
    var img = el.querySelector('img');
    if (!img || img.complete) { cb(); return; }
    img.addEventListener('load', cb, { once: true });
    img.addEventListener('error', cb, { once: true });
    setTimeout(cb, 2500);
  }

  function init() {
    var els = document.querySelectorAll('.ggprint:not([data-gg-init])');
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); whenLoaded(e.target, function () { run(e.target); }); }
      });
    }, { threshold: 0.35 }) : null;

    els.forEach(function (el) {
      el.setAttribute('data-gg-init', '');
      if (el.dataset.print === 'view' && io) io.observe(el);
      else whenLoaded(el, function () { run(el); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
